import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';



ReactDOM.createRoot(document.getElementById('root')).render(<App />);